export const CART = {
  PUSH_PRODUCT_TO_CART: 'pushProductToCart',
  INCREMENT_ITEM_QUANTITY: 'incrementItemQuantity',
  SET_CART_ITEMS: 'setCartItems',
  SET_CHECKOUT_STATUS: 'setCheckoutStatus'
}

export const PRODUCTS = {
  SET_PRODUCTS: 'setProducts',
  DECREMENT_PRODUCT_INVENTORY: 'decrementProductInventory',
  PRODUCT_DESCANNUMBER: 'productDesCanNumber',
  PRODUCT_ADDCANNUMBER: 'productAddCanNumber'
}
